import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

import { buildFields } from '../base/builders/buildValidationFields';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();
    const { name, parameters, parameters_hitch } = buildFields();

    return object().shape({
        api_key: string().when('type_algorithm', {
            is: 'static_api_key',
            then: () => string().required(REQUIRED_TEXT),
            otherwise: () => string().nullable(),
        }),
        name,
        parameters: object().shape({
            tax: parameters.tax,
            terms: parameters.terms,
        }),
        parameters_hitch,
        secret_key: string().when('type_algorithm', {
            is: 'static_api_key',
            then: () => string().required(REQUIRED_TEXT),
            otherwise: () => string().nullable(),
        }),
        type_proposal_template: string().when('type_algorithm', {
            is: 'static_api_key',
            then: () => string().required(REQUIRED_TEXT),
            otherwise: () => string().nullable(),
        }),
    });
};
